import { RgDefaults, RgCreate, RvDataListSets, RgDataSetID } from "@project-rouge/rg-core";
const RgDefaultCreate = (partial, type = partial.type, rvData = RvDataListSets[RgDataSetID.uk_01]) => {
  if (!type)
    throw new Error("You must specify an RG_TYPE");
  const defaultObj = RgDefaults[type];
  const obj = RgCreate({
    ...defaultObj,
    ...partial
  }, rvData);
  obj.data = { ...obj.data };
  return obj;
};
export {
  RgDefaultCreate
};
//# sourceMappingURL=index19.js.map
